import { render, staticRenderFns } from "./PracticeTasks.vue?vue&type=template&id=232951b5&scoped=true"
import script from "./PracticeTasks.vue?vue&type=script&lang=js"
export * from "./PracticeTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232951b5",
  null
  
)

export default component.exports